import CallApp from 'callapp-lib'
let CONFIG = {
  ios: 'https://itunes.apple.com/cn/app/Solestage_official/id6443823456?mt=8',
  android: 'https://www.pgyer.com/T3rp',
  scheme: 'SOLESTAGE',
  host: ''
}

/**
* 判断是否为微信浏览器
* 兼容ios
* */
// 判断当前是什么浏览器
function isWeixin () {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
}

function isQq () {
  // 判断微信、QQ等内置浏览器
  let sUserAgent = navigator.userAgent.toLowerCase()
  if (sUserAgent.match(/QQ/i) === 'qq') {
    return true
  } else {
    return false
  }
}

// 因为直播在无法在微信浏览器直接播放，限制打开
function liveAstrict () {
  // 微信,qq外部打开
  if (isWeixin()) {
    document.getElementById('guideZfbPayPage').style.display = 'block'
    return true
  } else {
    // 显示手动打开外置浏览器提示
    document.getElementById('guideZfbPayPage').style.display = 'none'
    return false
  }
}

function openApp (type, lang, path, param) {
  CONFIG.host = type === 'dev' ? 'com.solestagedev.solestage' : 'com.solestage.solestage'
  // 微信,qq外部打开
  if (isWeixin() || isQq()) {
    document.getElementById('guideZfbPayPage').style.display = 'block'
    return
  } else {
    // 显示手动打开外置浏览器提示
    document.getElementById('guideZfbPayPage').style.display = 'none'
  }
  // 获取当前路径
  var currentUrl = `https://publicity.mokekeji.com/solestage/download?environment=${type}&lang=${lang}`
  var u = navigator.userAgent
  var isIOSNum = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isIOSNum) {
    currentUrl = CONFIG.ios
  }
  const options = {
    scheme: {
      protocol: CONFIG.scheme, // APP 协议，URL Scheme 的 scheme 字段，就是你要打开的 APP 的标识
      host: CONFIG.host
    },
    appstore: CONFIG.ios, // 填写appstore的下载地址
    yingyongbao: CONFIG.android, // 填写应用宝的下载地址
    fallback: currentUrl, // 填写唤端失败后跳转的地址
    // 小技巧哈！要是仿照支付宝这种检测没有app后，点击打开app留在当前页面，appstore、yingyongbao、
    // fallback都写当前地址就好了window.location.href获取一下就好了
    timeout: 3000
  }
  const callLib = new CallApp(options)
  callLib.open({
    param: param,
    path: path
  })
  // 小技巧哈！这里因为后台直接返回没有Scheme的路径部分所以路由信息和参数是在
  // 一起我就懒得处理了就直接给到path也可以正常执行的比如：
  // Scheme:///aaaa/bbbb?login=1  整体路径
  // /aaaa/bbbb?login=1  path部分直接赋值上去就不用在处理参数问题了
  console.log(callLib.generateScheme({
  // 打印最终路径。。。。
  }))
}

export {
  openApp,
  liveAstrict
}
